import { getCallable } from "../_sdk/client";
import {
    GetExperimentsRequest, GetExperimentsResponse,
    InitializeAllExperimentsRequest, InitializeAllExperimentsResponse
} from "./types";
import { endpoints, apiName } from "./endpoints";

const getExperiments = getCallable<GetExperimentsRequest, GetExperimentsResponse>(apiName, "getExperiments", {
    ...endpoints.getExperiments,
    composer: request => {
        const searchParams = new URLSearchParams();
        searchParams.append("ids", request.ids.join(","));
        searchParams.append("browserId", request.browserId);
        searchParams.append("migrationStates", JSON.stringify(request.migrationStates));
        searchParams.append("overrideStates", JSON.stringify(request.overrideStates));

        return {
            url: `/experiments?${searchParams.toString()}`,
            options: {
                method: "GET"
            }
        };
    }
}, false);

const initializeAllExperiments = getCallable<InitializeAllExperimentsRequest, InitializeAllExperimentsResponse>(apiName, "initializeAllExperiments", {
    ...endpoints.initializeAllExperiments,
    composer: request => {
        return {
            url: `/experiments/initializeAll`,
            options: {
                method: "POST",
                body: JSON.stringify(request)
            }
        };
    }
}, false);

export const callables = {
    getExperiments,
    initializeAllExperiments
};
